import {
  OrgToTadpoleTransactionResponse,
  TransactionStatus,
  PaymentsService,
} from "client/openapi";
import { Dialog, DialogContent, DialogTrigger } from "components/Dialog";
import { Button, ButtonColor, ButtonFill, ButtonSize } from "components/Button";
import moment from "moment";
import { useState } from "react";
import Notifications from "util/notifications";
import { IoCheckmarkCircle, IoCloseCircle } from "react-icons/io5";
import { FaClock } from "react-icons/fa6";
import { getTransactionStatusColor } from "pages/manage/students/[id]/PaymentsTab/Transactions/statusHelper";
import TransactionDetailsPopup from "pages/manage/students/[id]/PaymentsTab/Transactions/TransactionMeetingDetails";

function PendingPayrollRuns({
  pendingPayrollRuns,
}: {
  pendingPayrollRuns: OrgToTadpoleTransactionResponse[];
}) {
  const [confirmingPayrollIds, setConfirmingPayrollIds] = useState<{
    [key: string]: boolean;
  }>({});
  const [processingPayrollIds, setProcessingPayrollIds] = useState<{
    [key: string]: boolean;
  }>({});

  return (
    <DialogContent className="notification-banner-dialog-content">
      <div className="w-full overflow-y-auto">
        <h2 className="text-xl font-bold mb-4 text-gray-800">
          Pending Payroll Runs
        </h2>
        <table className="w-full border-collapse">
          <thead className="sticky top-0 z-3 shadow-sm bg-white">
            <tr className="border-b-2 border-gray-300">
              <th className="text-left p-2 text-sm font-bold w-1/6">Date</th>
              <th className="text-left p-2 text-sm font-bold w-1/6">Amount</th>
              <th className="text-left p-2 text-sm font-bold w-1/6">Type</th>
              <th className="p-2 text-sm font-bold w-1/6 text-center">
                Status
              </th>
              <th className="p-2 text-sm font-bold w-1/6 text-center">
                Details
              </th>
              <th className="p-2 text-sm font-bold w-1/6 text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {pendingPayrollRuns.map((transaction, index) => {
              const date = moment(transaction.timestamp).format("MM/DD/YYYY");
              const amount = (transaction.amount / 100).toFixed(2);
              const type = "Funding Payroll";

              const statusIcon = (() => {
                const statusColor = getTransactionStatusColor(
                  transaction.status
                );
                switch (statusColor) {
                  case "green":
                    return <IoCheckmarkCircle className="mx-auto green-mark" />;
                  case "purple":
                    return (
                      <IoCheckmarkCircle className="mx-auto purple-mark" />
                    );
                  case "orange":
                    return (
                      <FaClock
                        className="mx-auto"
                        style={{ color: "#FFB341", fontSize: "20px" }}
                      />
                    );
                  case "red":
                    return <IoCloseCircle className="mx-auto red-mark" />;
                  default:
                    return (
                      <FaClock
                        className="mx-auto"
                        style={{ color: "lightblue", fontSize: "20px" }}
                      />
                    );
                }
              })();

              return (
                <tr
                  key={index}
                  className="bg-white border-b border-gray-200 hover:bg-gray-50"
                >
                  <td className="p-2 text-sm">{date}</td>
                  <td className="p-2 text-sm">${amount}</td>
                  <td className="p-2 text-sm">{type}</td>
                  <td className="p-2 text-sm text-center">{statusIcon}</td>
                  <td className="p-2 text-sm text-center">
                    <LazyTransactionDetailsPopup transaction={transaction} />
                  </td>
                  <td className="p-2 text-sm text-center">
                    {transaction.status ===
                      TransactionStatus.AWAITING_CONFIRMATION_TO_FUND_PAYROLL && (
                      <>
                        {!confirmingPayrollIds[transaction.id] ? (
                          <Button
                            onClick={() =>
                              setConfirmingPayrollIds((prev) => ({
                                ...prev,
                                [transaction.id]: true,
                              }))
                            }
                            color={ButtonColor.DARK_BLUE}
                            size={ButtonSize.EXTRA_SMALL}
                          >
                            Trigger
                          </Button>
                        ) : processingPayrollIds[transaction.id] ? (
                          <span className="text-green-600 text-xs">
                            Payroll Triggered
                          </span>
                        ) : (
                          <Button
                            onClick={() => {
                              setProcessingPayrollIds((prev) => ({
                                ...prev,
                                [transaction.id]: true,
                              }));
                              PaymentsService.queuePayroll({
                                transactionId: transaction.id,
                                orgId: transaction.org_id,
                              }).then(() => {
                                Notifications.success("Payroll will now run!");
                              });
                            }}
                            color={ButtonColor.GREEN}
                            size={ButtonSize.EXTRA_SMALL}
                          >
                            Confirm Payroll Run
                          </Button>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </DialogContent>
  );
}

function LazyTransactionDetailsPopup({
  transaction,
}: {
  transaction: OrgToTadpoleTransactionResponse;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <Button
          color={ButtonColor.PURPLE}
          size={ButtonSize.EXTRA_SMALL}
          fill={ButtonFill.HOLLOW}
        >
          Details
        </Button>
      </DialogTrigger>
      {open && <TransactionDetailsPopup transaction={transaction} />}
    </Dialog>
  );
}

export default PendingPayrollRuns;
